import React, { Fragment } from 'react'
import { Breadcrumbs } from '../../../../AbstractElements';
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import MissingDatesView from './MissingDatesView';

const MissingDatesReport = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Report" title="Missing Dates Report" mainTitle="Missing Dates Report" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <MissingDatesView />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default MissingDatesReport